import axios from "axios";
import saveAs from "file-saver";
import { getBlob, getStorage, ref } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";
import { ToastUtilities } from "@src/libs/react-toastify/ToastUtilities";

export const downloadFirebaseFile = (url: string, name?: string) => {
  return getBlob(ref(getStorage(), url)).then((blob) => {
    saveAs(blob, name);
  });
};

export const downloadExternalFileURL = (url: string, name?: string) => {
  return axios
    .get(url, { responseType: "blob" })
    .then((response) => {
      const type = response.headers["Content-Type"] as string;
      const blob = new Blob([response.data], { type });
      saveAs(blob, name);
    })
    .catch((error) => console.error(error));
};

export function downloadFunctionsFileURL(propertyID: string, fileID: string, fileName: string) {
  return httpsCallable(
    getFunctions(undefined, "europe-west1"),
    "getExternalFileURL"
  )({
    propertyID: propertyID,
    fileID: fileID,
  })
    .then((response) => {
      if (typeof response.data === "string") {
        downloadExternalFileURL(response.data, fileName);
      }
    })
    .catch((error) => {
      ToastUtilities.presentServerError(error);
    });
}

